module.exports = __webpack_public_path__ + "img/zfcg_13.abc45ce2.png";